import { useRouter } from "@tanstack/react-router";
import { useCallback } from "react";
import { authClient } from "@/auth";

export function useRefetchUser() {
	const router = useRouter();
	return useCallback(async () => {
		await authClient.getSession({ query: { disableCookieCache: true } });
		await router.invalidate();
	}, [router]);
}
